<template>
  <speaker v-if="speaker" :speaker-config="speakerConfig" :speaker="speaker"></speaker>
</template>

<script>
import Speaker from './com-author'

export default {
  props: [
    'id'
  ],
  components: {
    Speaker
  },
  data () {
    return {
    }
  },
  computed: {
    speakerConfig () {
      return this.$store.state.speakerConfig
    },
    speaker () {
      return this.$store.state.speakers[this.id] || {}
    }
  },
  beforeDestroy () {
  },
  methods: {
  }
}
</script>

<style lang="sass" scoped>

.page-speaker
  background-color: #f5f7f8
  padding: 100px 0
  +mobile
    padding: 30px 0
  .container
    display: flex
    justify-content: space-between
    align-items: center
    +mobile
      display: block
  .avatar
    margin-right: 60px
    flex-shrink: 0
    text-align: center
    +mobile
      margin-right: 0
  .avatar img
    width: 237px
    height: 237px
    padding: 5px
    border: 1px solid #f4f6f7
    // border: 2px solid #777777
    border-radius: 50%
    background-color: #fff
    +mobile
      width: 43vw
      height: 43vw
  h1
    font-size: 38px
    color: #3e3a39
    +mobile
      text-align: center
      font-size: 15px
      color: var(--primary-color)
      margin-top: 10px
  h6
    margin-top: 8px
    margin-bottom: 21px
    font-size: 18px
    color: #8e9ca9
    +mobile
      font-size: 12px
      text-align: center
      color: #898989
      margin: 10px 0 20 0
  .content
    color: #3e3a39
    text-align: justify
    font-size: 16px
    line-height: 1.8
    +mobile
      font-size: 14px
    p, dl, ol, ul, blockquote, pre, table, h1, h2, h3, h4, h5, h6
      &:not(:last-child)
        margin-bottom: 1.2em
    h1, h2, h3, h4, h5, h6
      margin: 1.2em 0
    ul, ol
      margin-left: 1.8em
    ul li
      list-style-type: disc
    ol li
      list-style-type: decimal
</style>
